import { handlers as clientDomainHandlers } from './client-domain/client-domain.mock';
import { handlers as mediaHandlers } from './media/media.mock';
import { handlers as oauthHandlers } from './oauth/oauth.mock';
import { handlers as orderingServiceHandlers } from './ordering-service/ordering-service.mock';
import { handlers as giftCardServiceHandlers } from './giftcard-service/giftcard-service.mock';
import { handlers as paymentsHandlers } from './payments/payments.mock';
import { handlers as userDomainHandlers } from './user-domain/user-domain.mock';
import { handlers as transactionHandlers } from './transactions/transactions.mock';
import { handlers as loyaltyDomainHandles } from './loyalty-domain/loyalty-domain.mock';
import { handlers as customerAppContentHandlers } from './customer-app-content/customer-app-content.mock';
import { handlers as offersDomainHandlers } from './offers-domain/offers-domain.mock';
import { handlers as autoTaggerHandlers } from './auto-tagger-service/auto-tagger-service.mock';
import { handlers as qaEnvHandlers } from './qa-env/qa-env.mock';
import { handlers as adminApiHandlers } from './admin-api/admin-api.mock';
import { handlers as menuServiceHandlers } from './menu-service/menu-service.mock';
import { handlers as reportsServiceHandlers } from './reports-service/reports-service.mock';
import { handlers as walletServiceHandlers } from './wallet-service/wallet-service.mock';
import { handlers as emailTemplateServiceHandlers } from './client-domain/email-template-service/email-template-service.mock';
import { handlers as surveysHandlers } from './surveys/surveys.mock';
import { handlers as connectDomainHandlers } from './connect-domain/connect-domain.mock';
import { handlers as smsReportsServiceHandlers } from './sms-reports-service/sms-reports-service.mock';
import { handlers as giftcardAchHandlers } from './giftcard-ach-service/giftcard-ach-service.mock';
import { handlers as mlServiceHandlers } from './ml-service/ml-service.mock';
import { handlers as appHomeConfigHandlers } from './client-domain/app-home-config/app-home-config.mock';

export const handlers = [
  ...clientDomainHandlers(),
  ...oauthHandlers(),
  ...mediaHandlers(),
  ...orderingServiceHandlers(),
  ...giftCardServiceHandlers(),
  ...paymentsHandlers(),
  ...autoTaggerHandlers(),
  ...userDomainHandlers(),
  ...transactionHandlers(),
  ...loyaltyDomainHandles(),
  ...customerAppContentHandlers(),
  ...offersDomainHandlers(),
  ...qaEnvHandlers(),
  ...adminApiHandlers(),
  ...menuServiceHandlers(),
  ...reportsServiceHandlers(),
  ...walletServiceHandlers(),
  ...emailTemplateServiceHandlers(),
  ...surveysHandlers(),
  ...connectDomainHandlers(),
  ...smsReportsServiceHandlers(),
  ...giftcardAchHandlers(),
  ...mlServiceHandlers(),
  ...appHomeConfigHandlers(),
];
